export default __webpack_public_path__ + "static/media/bankoleoluwatosin.905aec3c.png";